module.exports = __webpack_public_path__ + "media/components/lesson4/statics/selectImage-3d43e17f4f2157a2159b92652e8d701d.png";